import { Grid } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import { PatientManagementStore } from "app/PatientManagement/PatientManagementStore";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import { memo, useEffect, useState } from "react";
import ListReviewFeedback from "./ListReviewFeedback";
import SearchReviewFeedback from "./SearchReviewFeedback";

const ReviewFeedbackIndex = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const {
    searchReviewFeedback,
    handleChangeFormSearchReviewFeedback,
    initReviewFeedbackPatientId,
    dataVoucherFeedback,
  } = PatientManagementStore.reviewFeedbackStore;
  const { initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;
  console.log("🚀 ~ ReviewFeedbackIndex ~ initialPatient:", initialPatient);
  const [isOpenFillter, setOpenFillter] = useState(true);

  useEffect(() => {
    // Nếu có patientId và đã có dữ liệu patientInfo (từ initialPatient)
    if (patientId && initialPatient?.patientInfo?.id) {
      const emrMappingId = initialPatient?.patientInfo?.id;
      const clientId = initialPatient?.patientInfo?.crmUuid;
      handleChangeFormSearchReviewFeedback({
        ...searchReviewFeedback,
        clientId: clientId ? clientId : emrMappingId,
        emrMappingId,
      });
    }
  }, [patientId]);
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <div
          className=" flex justify-between gap-2"
          style={{ fontSize: "16px" }}
        >
          <span
            className="cards-header flex items-center pointer"
            style={{ fontWeight: "bold", padding: "10px" }}
          >
            Đánh giá & FeedBack
            <FilterListIcon
              style={{ marginRight: 8, cursor: "pointer" }}
              onClick={() => setOpenFillter(!isOpenFillter)}
            />
          </span>
        </div>
      </Grid>
      <Grid item xs={12} sm={6}>
        {isOpenFillter && (
          <>
            <style>
              {`
                        @keyframes slideDownFade {
                        0% {
                            opacity: 0;
                            transform: translateY(-10px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                        }
                    `}
            </style>
            <div
              style={{
                animation: "slideDownFade 0.3s ease forwards",
              }}
            >
              <Formik
                initialValues={searchReviewFeedback}
                onSubmit={(values) => {
                  handleChangeFormSearchReviewFeedback(values);
                }}
                enableReinitialize
              >
                <Form autoComplete="off">
                  <SearchReviewFeedback />
                </Form>
              </Formik>
            </div>
          </>
        )}
      </Grid>
      <Grid item xs={12}>
        <ListReviewFeedback />
      </Grid>
    </Grid>
  );
};

export default memo(observer(ReviewFeedbackIndex));
